<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background" @click="close"></div>
    <aside class="modal-card">
      <section class="modal-card-body">
        <span class="close cursor-pointer is-pulled-right" @click="close"><i class="fal fa-times"></i></span>
        <div class="subtitle mt-3">
          {{ $t('sectionProfile.pinSwapModal.sendExchange1') }}
          <br>
          {{ $t('sectionProfile.pinSwapModal.sendExchange2') }}
           <strong class="has-text-primary">{{ userName }}</strong>.</div>
        <hr class="horizontal-line">
        <div>
          <strong>{{ $t('sectionProfile.pinSwapModal.note1') }}</strong>{{ $t('sectionProfile.pinSwapModal.note2') }}
          <br>
          {{ $t('sectionProfile.pinSwapModal.note3') }}
          <strong>{{ $t('sectionProfile.pinSwapModal.note4') }}</strong>{{ $t('sectionProfile.pinSwapModal.note5') }}
        </div>
        <button class="button is-primary is-uppercase mt-6 mb-4" @click="confirm">Confirm</button>
        <br>
        <input type="checkbox" id="dontShowAgain" name="dontShowAgain" v-model="dontShowAgain">
        <label for="dontShowAgain">{{ $t('sectionProfile.pinSwapModal.dontShowAgain') }}.</label><br>
      </section>
    </aside>
  </div>
</template>

<script>

// import i18n from '@/i18n'
import auth from '@/mixins/auth'

export default {
  name: 'modalSwapPinWarning',
  components: {},
  mixins: [auth],
  props: ['userName'],
  data: function () {
    return {
      active: false,
      dontShowAgain: false
    }
  },
  methods: {
    showModal: function () {
      this.active = true
      this.dontShowAgain = false
    },
    confirm: function () {
      if (this.dontShowAgain) {
        const settings = { showPinSwapWarning: false }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      }
      this.active = false
      this.$emit('modalSuccess')
    },
    close: function () {
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

$modal-body-color: #F2F2F2;

.modal-card {
  background: $modal-body-color;
  text-align: center;
}
.modal-card-body {
  padding-bottom: 3rem;
}
.close {
  font-size: 1.3rem;
  background-color: transparent;
  opacity: 0.75;
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  border: none;
}
.horizontal-line {
  background-color: $primary;
  width: 20%;
  margin-left: auto;
  margin-right: auto;
}
</style>
